<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .editable {
    margin: 0 6px 0px 0;
    display: inline-flex;
    vertical-align: middle;
  }

  .editable-click {
    cursor: pointer;
    font-weight: 500;
    text-decoration: underline;

    &.editable-empty {
      font-style: italic;
    }
  }

  .editable-modal {
    z-index: 10;
    display: flex;
    min-width: 170px;
    text-align: left;
    padding: 16px 16px 24px;
    border-radius: 16px;
    background-color: $salesflow-bg-body;
    flex-direction: column;
    box-shadow: 0 5px 15px rgba(0, 0, 0, .3);

    .editable-title {
      h3 {
        color: $salesflow-font-gray;
        font-family: Montserrat;
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: -0.21px;
        line-height: 130%;
        text-transform: none;
        margin-top: 12px;
        margin-bottom: 0px;
      }
    }

    .editable-content {
      margin-top: 8px;

      .input-group-text {
        border: none;
        border-radius: 5px 0 0 5px;
        background: $salesflow-bg-content;
        padding: 0.375rem 0rem 0.375rem 1.2rem;
        background-color: $salesflow-bg-content;
        color: $salesflow-font-dark;
      }

      .input-group {
        padding: 0px;
        background-color: $salesflow-bg-content;
        border-radius: 8px;
        outline: 1px solid $salesflow-outline-gray-medium;

        input.form-control {
          outline: 0px;
        }
      }

      input.form-control {
        border: none;
        border-radius: 8px;
        background: $salesflow-bg-content;
        padding: 17px 12px;
        outline: 1px solid $salesflow-outline-gray-medium;
        @include salesflow-text();
      }

      button {
        margin: 5px auto 0;
      }
    }
  }

  .vdp-datepicker__calendar {
    border: none;
    width: 260px;

    .cell.selected,
    .cell.selected:hover {
      color: #fff;
      background: rgb(39, 174, 96);
    }
  }

  input.form-control,
  select.form-control {
    background-color: #ffffff;
  }

  select.form-control {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    background-image: url('/build/icons/icon-down.png') !important;
    background-repeat: no-repeat !important;
    background-position: right 14px center !important;
    background-size: 0.625em !important;
  }

  ::v-deep .popper[x-placement^="bottom"] .popper__arrow {
    border-width: 0px 25px 10px 25px !important;
    border-bottom-color: $salesflow-bg-body !important;
  }

  ::v-deep .popper[x-placement^="top"] .popper__arrow {
    border-width: 10px 25px 0px 25px !important;
    border-top-color: $salesflow-bg-body !important;
  }
</style>

<template>
  <div class="editable">
    <Popper
      trigger="click"
      transition="fade"
      :options="popper.options"
      ref="popper"
      @show="focus"
    >
      <div
        class="popper editable-modal"
        v-show="! isType('select') || isType('select') && options && options.length > 0"
      >
        <div
          class="editable-title"
          v-if="title"
        >
          <h3>
            {{ title }}
            <small>
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="saving"
              />
            </small>
          </h3>
        </div>
        <div
          class="editable-content"
          :id="id"
        >
          <form @submit.prevent="submit()">
            <input
              type="text"
              class="form-control"
              v-model="updateTo"
              @blur="submit"
              @input="onInputChangeTitle"
              v-if="isType('text')"
            >

            <InputDateTimepicker
              input-class=""
              v-model="updateTo"
              :type="type"
              :future="false"
              v-if="isType('date', 'datetime')"
              @input="submit"
            />

            <div
              class="input-group"
              v-if="isType('decimal')"
            >
              <span class="input-group-text">R$</span>
              <Cleave
                class="form-control"
                :options="cleave.options"
                v-model="updateTo"
                @blur="submit"
                @input="onInputChangeValue"
              />
            </div>

            <select
              class="form-control"
              @input="select"
              v-if="isType('select')"
            >
              <option>{{ placeholder }}</option>
              <option
                :key="option.value"
                :value="option.value"
                v-for="option in options"
                :selected="isSelected(option)"
              >
                {{ option.text }}
              </option>
            </select>
          </form>
        </div>
        <!-- <div class="text-center mt-3">
          <button class="btn btn-primary">Salvar</button>
        </div> -->
      </div>

      <div
        class="editable-click"
        :class="editableClickClass"
        slot="reference"
      >
        <span v-if="text === placeholder">
          {{ placeholder }}
        </span>
        <span v-else>
          {{ formattedValue }}
        </span>
      </div>
    </Popper>
  </div>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import Cleave from 'vue-cleave-component';
import dayjs from '../../core/dayjs';
import { currencyFormat } from '../../helpers/currencyFormat';

export default {
  props: {
    url: {
      default: null,
    },
    field: {
      default: null,
    },
    title: {
      default: null,
    },
    value: {
      default: null,
    },
    options: {
      default: null,
    },
    placeholder: { // type mixed
      default: null,
    },
    type: { type: String, default: 'text' },
    reload: { type: Boolean, default: false },
    displayText: { type: String, default: null },
    customClass: { type: String, default: '' },
  },

  components: {
    Cleave,
    Popper,
  },

  directives: {
    focus: {
      inserted: (el) => el.focus(),
    },
  },

  data () {
    return {
      id: `editable-${Math.random().toString(36).substring(7)}`,
      show: false,
      saving: false,
      updateTo: null,
      popper: {
        options: {
          modifiers: {
            offset: { offset: '0,6px' },
          },
        },
      },
      cleave: {
        types: 'decimal',
        options: {
          numeral: true,
          delimiter: '.',
          numeralDecimalMark: ',',
          numeralPositiveOnly: true,
          numeralDecimalScale: 2,
        },
      },
    };
  },

  created () {
    this.updateTo = this.content;
  },

  computed: {
    content () {
      if (typeof this.value === 'object') {
        return this.value[this.field];
      }

      return this.value || null;
    },

    empty () {
      if (this.content === null) {
        return true;
      }

      if (typeof this.content === 'number') {
        return this.content === 0;
      }

      return this.content.length === 0;
    },

    text () {
      if (this.displayText) {
        return this.displayText;
      }

      if (this.empty && this.type !== 'decimal') {
        return this.placeholder;
      }

      return this.content;
    },

    editableClickClass () {
      return (`${this.empty ? 'editable-empty' : ''} ${this.customClass}`).trim();
    },

    formattedValue () {
      if (this.isType('date')) {
        return dayjs(this.content).format('LD');
      }

      if (this.isType('datetime')) {
        return dayjs(this.content).format('LDT');
      }

      if (this.isType('decimal')) {
        return currencyFormat(this.content);
      }

      return this.text;
    },
  },

  methods: {
    onInputChangeTitle(event) {
      this.$emit('field-changed-title', event?.target?.value);
    },

    onInputChangeValue(event) {
      this.$emit('field-changed-value', event?.target?.value);
    },

    focus () {
      if (this.isType('select', 'date')) {
        return;
      }

      try {
        Vue.nextTick(() => {
          document.querySelector(`#${this.id} input`).focus();
        });
      } catch (e) {
        console.warn(e);
      }
    },

    isType (...types) {
      return types.indexOf(this.type) !== -1;
    },

    isSelected (option) {
      return this.updateTo == option.value
            || this.updateTo == option.text
            || this.content == option.value
            || this.content == option.text;
    },

    select (event) {
      this.updateTo = event.target.value;
      this.submit();
    },

    shouldUpdate () {
      if (this.saving || ! this.updateTo) {
        return false;
      }

      if (! this.isType('date', 'datetime')) {
        return this.updateTo !== this.content;
      }

      const flag = this.isType('date') ? 'day' : 'second';

      /**
       * Passing in day will check day, month, and year. without milliseconds
       *
       * https://day.js.org/docs/en/query/is-same
       */
      return ! dayjs(this.updateTo).isSame(dayjs(this.content), flag);
    },

    submit () {
      if (! this.shouldUpdate()) {
        return;
      }

      this.saving = true;

      this.$http.put(this.url, { [this.field]: this.updateTo })
        .then(({ data }) => {
          this.$emit('input', data);
          this.$emit('update', this.updateTo);

          if (this.reload === false) {
            this.saving = false;

            return this.close();
          }

          window.location.reload();
        })
        .catch(() => {
          this.saving = false;
        });
    },

    close () {
      this.$refs.popper.doClose();
    },
  },
};
</script>
